/* eslint-disable no-nested-ternary */
/** @jsx jsx */
import FlexBox from 'components/atoms/FlexBox';
import { SubActionButton } from 'components/atoms/Button';
import { css, jsx } from '@emotion/core';
import Accordion from 'components/molecules/Accordion';
import ChangeLogModal from 'components/molecules/ChangeLogModal';
import IconLabelButton from 'components/molecules/IconLabelButton';
import Modal from 'components/molecules/Modal';
import DataTable from 'components/organismos/DataTable/DataTable';
import { grayScale } from 'components/styles';
import React from 'react'; 
import { ActionButton } from 'components/atoms/Button/SubActionButton';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import Applying36AgreementDomain from '../domain/applying36AgreementDomain';
 import { useApplyingTransferForm } from './hook';
import TextTooltip from 'components/molecules/TextTooltip';

const Agreement36Accordion: React.FC<{
  list: Applying36AgreementDomain[]
  fetchApplyingList ?: any
  fetchApprovedList ?: any
  fetchRejectedList ?: any
  setApplyingAgreement36List ?: any
}> = ({
  list, fetchApprovedList, fetchRejectedList, setApplyingAgreement36List,
}) => {
  //const history = useHistory();
  const {
    changeLogData,
    setChangeLogData,
    changeLogModalOpen,
    setChangeLogModalOpen,
    setSelectChangelog,
    fetchChangeLogAgreement36,
  } = useApplyingTransferForm(list);
  const history = useHistory();
  const columns = React.useMemo(
    () => [
      {
        Header: '',
        id: 'edit',
        accessor: 'edit',
        Cell: (cell: {
          row: { isExpanded: boolean; original: any; index: number };
          data: any;
        }) => (
          <FlexBox customStyle={css({ justifyContent: 'space-evenly' })}>
            <SubActionButton
              text="編集"
              onClick={() => {
                sessionStorage.setItem('attendStampList.targetDateFrom', moment(cell.row.original.stampListStartTime).format('YYYY-MM-DD'));
                sessionStorage.setItem('attendStampList.targetDateTo', moment(cell.row.original.stampListEndTime).format('YYYY-MM-DD'));
                sessionStorage.setItem('attendStampList.orgCode', String(cell.row.original.orgCode));
                sessionStorage.setItem('attendStampList.staffCode', String(cell.row.original.staffCode));

                sessionStorage.setItem('application.orgCode', String(cell.row.original.orgCode));
                sessionStorage.setItem('application.staffCode', String(cell.row.original.staffCode));

                sessionStorage.setItem('application.dispStaffName', `${cell.row.original.staffCode} ${cell.row.original.staffName}`);
                sessionStorage.setItem('application.targetDate', moment(cell.row.original.targetDate).format('YYYY-MM-DD'));

                sessionStorage.setItem('application.achievementId', cell.row.original.achievementId || '');
                sessionStorage.setItem('application.stampVersion', cell.row.original.version || '');
                sessionStorage.setItem('application.modifierApplicationId', cell.row.original.modifierApplicationId || '');

                sessionStorage.setItem('application.returnDestination', window.location.pathname);
                sessionStorage.setItem('attendStampList.returnDestination', window.location.pathname);


                history.push('attendApplicationList/attendAgreement36Application');
              }}
              action={ActionButton.EDIT}
            />
          </FlexBox>

        ),
        disableSortBy: true,
      },
      {
        Header: '申請者',
        accessor: 'applicant',
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "left" }}>
            {cell.row.original.staffCode}<br></br>{cell.row.original.staffName}
          </div>
        )
      },
      {
        Header: '申請日時',
        accessor: 'applicationDate',
      },
      {
        Header: '組織名',
        accessor: 'orgName',
      },
      {
        Header: (any: any) => '対象月',
        id: '',
        accessor: 'targetDate',
        Cell: (cell: {
          row: { isExpanded: boolean; original: any; index: number };
          data: any;
        }) => {
          return(
          <div style={{ textAlign: 'center' }}>
            <div>
              <div>{cell.row.original.targetDate}</div>
              <IconLabelButton
                onClick={() => {
                  fetchChangeLogAgreement36(cell.row.original.rawData);
                  setChangeLogModalOpen(true);
                  setSelectChangelog('0');
                }}
                text="更新履歴"
                textAlign="center"
                isIcon={false}
              />
            </div>
          </div>
        )},
      },
      {
        Header: '申請\n種別',
        accessor: 'modifiyStatusName',
      },
      {
        Header: (any: any) => '見込み残業時間',
        id: '',
        accessor: 'applicationExpectedOvertimeHours',
        Cell: (cell: {
          row: { isExpanded: boolean; original: any; index: number };
          data: any;
        }) => {
          return(
            <div style={{ textAlign: 'center' }}>{cell.row.original.applicationExpectedOvertimeHours}時間</div>
        )},
      },
      {
        Header: '申請理由',
        accessor: 'applicationReason',
        Cell: (cell: {row: { isExpanded: boolean; original: any }})=>(
          <TextTooltip text={cell.row.original?.applicationReason} textDis={(
            <div className="ellipsis headline-cell-width-230"
              style={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                width: '230px'
              }}>
                {cell.row.original?.applicationReason}
            </div>
          )} />  
        )
      },
    ],
    [fetchChangeLogAgreement36, setChangeLogModalOpen, setSelectChangelog],
  );

  return (
    <React.Fragment>
    <div className="margin-accordian" 
      css={css`
        table th:nth-of-type(1) {
          width: 40px;
        }
        table th:nth-of-type(2) {
          width: 120px;
        }
        table td:nth-of-type(2) {
          white-space: pre-line;
        }
        table tbody tr td:nth-of-type(2) {
          text-align: center;
        }
        table th:nth-of-type(3) {
          width: 80px;
          }
        table tbody tr td:nth-of-type(3) {
          text-align: center;
        }  
        table th:nth-of-type(4) {
          width: 190px;
        }
        table th:nth-of-type(5) {
          width: 80px;
        }
        table td:nth-of-type(6),
        table th:nth-of-type(6) {
          width: 60px;
          white-space: pre;
        }
        table th:nth-of-type(7) {
          width: 150px;
        }
        table th:nth-of-type(8) {
          width: 200px;
        }
        `}
    >
      <Accordion
        text={`限度時間超過申請 (${list.length}件）`}
        callBack={() => {}}
      >
        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', padding:'0 10px 10px' }}>
          <DataTable 
            columns={columns} 
            classNameParrant="border-left-right border-bottom"
            className="table-no-border-left-right" 
            data={list} 
            isGlobalFilter={true} 
            minWidth="100%" 
            sortBy={[{ id: 'applicationDate', desc: true }]} 
            />
        </div>
      </Accordion>
    </div>
    {/* Change log  */}
    <div css={css('>div>div{ width: 1000px }')}>
      <Modal
        closeHandler={() => {
          setChangeLogModalOpen(false);
          setChangeLogData([]);
        }}
        open={changeLogModalOpen}
        title="更新履歴"
        submitText="閉じる"
        onSubmit={() => {
          setChangeLogModalOpen(false);
          setChangeLogData([]);
        }}
        closeText=""
      >
        <ChangeLogModal changeLogData={changeLogData} request='45時間超過申請'/>
      </Modal>
    </div>
    {/* ./Change log  */}
    </React.Fragment>
  );
};

export default Agreement36Accordion;
